import { gql } from "@apollo/client"

export const AGGREGATE_COUNTRY = gql`
	query(
		$where: CountryWhereInput
		$orderBy: [CountryOrderByWithRelationInput]
		$cursor: CountryWhereUniqueInput
		$take: Int
		$skip: Int
	){
		aggregateCountry(
			where: $where
			orderBy: $orderBy
			cursor: $cursor
			take: $take
			skip: $skip
		){
			_count{
				id
				createdAt
				updatedAt
				isVisible
				title
				description
				currency
				locale
				images
				_all
			}
			_min{
				id
				isVisible
				title
				description
				currency
				locale
			}
			_max{
				id
				isVisible
				title
				description
				currency
				locale
			}
		}
	}
`